import React from 'react';
import { Icon } from 'udesk-ui';
import { FeishuDepFoundResponse } from 'src/api/types';

export interface DataNode {
    title: string;
    key: string;
    isLeaf?: boolean;
    children?: DataNode[];
    icon?: any;
    userId?: string;
    isEmployee?: boolean;
}

export const getNode = (data: FeishuDepFoundResponse) => {
    let children = Array.isArray(data.childDeps)
        ? (data.childDeps || []).map((d) => getNode(d))
        : undefined;

    if (Array.isArray(data.employees)) {
        let employee = data.employees.map((e) => {
            return {
                key: `${data.depId}-${e.userId}`,
                isLeaf: true,
                title: e.name,
                parentId: e.depId,
                id: e.userId,
                isEmployee: true,
                userId: e.userId,
            };
        });

        if (employee.length) {
            children = [...(children ?? []), ...employee];
        }
    }

    return {
        key: `${data.depId}`,
        title: data.depName,
        parentId: data.depParentId,
        id: data.id,
        // selectable: data.leaf,
        children,
    };
};

export const updateExpandNode = (data: DataNode[], expandedKeys: string[]) => {
    return data.map((i) => ({
        ...i,
        icon: !i.isEmployee ? (
            <Icon
                type={expandedKeys.includes(i.key) ? 'ic-folder-open' : 'FolderFilled'}
                style={{ color: '#1A6EFF' }}
                antdIcon={!expandedKeys.includes(i.key)}
            />
        ) : (
            <div className="employee-icon"></div>
        ),
        children: Array.isArray(i.children)
            ? updateExpandNode(i.children || [], expandedKeys)
            : undefined,
    }));
};

export const updateTreeData = (list: DataNode[], key: React.Key, newNode: DataNode): DataNode[] => {
    return list.map((node) => {
        if (node.key === key) {
            return newNode;
        } else if (node.children) {
            return {
                ...node,
                children: updateTreeData(node.children, key, newNode),
            };
        } else {
            return node;
        }
    });
};
